import SessionApi from '@opendoor/shared-fe/build/api/session';
import {
  PromptGoogleOneTapOptions,
  promptGoogleOneTap as sharedPromptGoogleOneTap,
} from '@opendoor/shared-fe/build/googleOneTap';

import { CosmosTrackingActions, CosmosTrackingCategory } from 'helpers/observability';

import { GOOGLE_CLIENT_ID, RAILS_URL, XSRF_COOKIE_KEY } from '../globals';

export const Session = new SessionApi(XSRF_COOKIE_KEY, RAILS_URL);

export const promptGoogleOneTap = (
  analyticsName: string,
  success: () => void,
  trackEvent: PromptGoogleOneTapOptions<
    CosmosTrackingCategory,
    CosmosTrackingActions
  >['trackEvent'],
  trackError: PromptGoogleOneTapOptions<
    CosmosTrackingCategory,
    CosmosTrackingActions
  >['trackError'],
): void => {
  sharedPromptGoogleOneTap<CosmosTrackingCategory>({
    analyticsName,
    trackEvent,
    trackError,
    clientId: GOOGLE_CLIENT_ID,
    onSuccess: (response) => {
      Session.register(undefined, undefined, undefined, undefined, response.credential).then(() =>
        success(),
      );
    },
  });
};
